export default __webpack_public_path__ + "assets/enterprise-two-two.4123e6b7323c54df06714a5450ea4405.png";